import React from 'react';
import { Link } from 'react-router-dom';

export const QuestionarioCarrosSuccess = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-orange-100 flex items-center justify-center p-4" data-testid="questionario-carros-success-screen">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center" data-testid="questionario-carros-success-card">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-testid="questionario-carros-success-icon">
          <span className="text-4xl">🚗</span>
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-4" data-testid="questionario-carros-success-title">Questionário Enviado!</h2>
        <p className="text-gray-600 mb-6" data-testid="questionario-carros-success-message">
          Obrigado pelo seu interesse! Nossa equipe buscará veículos que atendam suas preferências e entrará em contato em breve.
        </p>
        <div className="flex gap-3" data-testid="questionario-carros-success-actions">
          <Link
            to="/"
            className="flex-1 px-4 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition"
            data-testid="questionario-carros-success-home-link"
          >
            Voltar ao Site
          </Link>
        </div>
      </div>
    </div>
  );
};
